module.exports = __webpack_public_path__ + "static/media/icon-card-cv-saptalent.e7a9bbd0.svg";